import { render, staticRenderFns } from "./DormGroup.vue?vue&type=template&id=402444cd&scoped=true"
import script from "./DormGroup.vue?vue&type=script&lang=js"
export * from "./DormGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402444cd",
  null
  
)

export default component.exports